export default "__VITE_ASSET__B9WIMYrV__"